function injectStyle (ssrContext) {
  require("!!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6106cfce\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=styles&index=0!./customerInfo.vue")
}
var Component = require("!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=script&index=0!./customerInfo.vue"),
  /* template */
  require("!!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6106cfce\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=template&index=0!./customerInfo.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6106cfce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/customerManagement/customerInfo.vue
// module id = 1454
// module chunks = 0